import PropTypes from 'prop-types';
import React from 'react';
import { PieChart, Cell, Pie, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

/**
 * Input to search someting
 * @constructor
 * @extends Component
 */
class Chart extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            width: 100,
            height: 300,
            init: false
        };
    }

    renderChart() {
        const { type } = this.props;

        if (type === 'pie') {
            return this.renderPieChart();
        }
        return this.renderLineChart();
    }

    refCallback(element) {
        if (element && !this.state.init) {
            this.setState({
                init: true,
                width: element.getBoundingClientRect().width
            });
        }
    }

    renderLineChart() {
        const { data, labels } = this.props;
        const { height } = this.state;

        return (
            <div ref={this.refCallback.bind(this)} style={{ width: '100%', height: height }}>
                <ResponsiveContainer>
                    <LineChart data={data}>
                        <XAxis dataKey="name" />
                        <YAxis />
                        <CartesianGrid strokeDasharray="3 3" />
                        <Tooltip />
                        {labels.map((label, index) => {
                            return <Line key={'line-' + index} type="monotone" dataKey={label.value} stroke={label.color} />;
                        })}
                    </LineChart>
                </ResponsiveContainer>
            </div>
        );
    }

    renderPieChart() {
        const { data } = this.props;
        const { height } = this.state;
        const COLORS = ['#3DCC91', '#FFB366', '#FF7373'];

        return (
            <div ref={this.refCallback.bind(this)} style={{ width: '100%', height: height }}>
                <ResponsiveContainer>
                    <PieChart>
                        <Pie data={data} dataKey="value" label={true} labelLine={false}>
                            {data.map((entry, index) => (
                                <Cell key={index} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        );
    }

    /**
     * render the LineChart
     * @return {ReactElement} - The Chart
     */
    render() {
        return this.renderChart();
    }
}

Chart.propTypes = {
    labels: PropTypes.array,
    type: PropTypes.string,
    data: PropTypes.array.isRequired
};

Chart.defaultProps = {
    labels: [],
    type: 'line'
};

export default Chart;
